import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useApi } from "../../../../../../hooks/useApi";
import Loader from "../../../../../DefaultStyles/Loader";
import { Textarea } from "../../../../../Input/Textarea";
import DefaultModalLayout from "../../../../../Modal/DefaultModalLayout";
import {
  DeleteModalCommonProps,
  DeleteModalLabel,
} from "../../../../Users/UserDetail/CommentModal/CommentDeleteModal";

interface TempAccountDeleteModalProps extends DeleteModalCommonProps {
  tempAccountId: number;
}

export default function TempAccountDeleteModal({
  tempAccountId,
  cancelEvent,
  closeEvent,
}: TempAccountDeleteModalProps) {
  console.log(tempAccountId);

  const [deleteBtnClick, setDeleteBtnClick] = useState(false);
  const [reason, setReason] = useState("");

  // 임시 계정 삭제
  const { response, error, loading } = useApi({
    method: "delete",
    url: deleteBtnClick ? `temp-account/${tempAccountId}` : undefined,
    data: {
      reason,
    },
  });

  console.log(error);

  useEffect(() => {
    if (error) {
      if (error.code === 400) {
        toast.error("임시 계정 삭제 권한이 없습니다.");
      }
    }
  }, [error]);

  useEffect(() => {
    if (response?.status === 200) {
      if (closeEvent) {
        closeEvent();
        cancelEvent();
      }
      toast.success("임시 계정에서 삭제되었습니다.", {});
    }
  }, [response]);

  return (
    <DefaultModalLayout
      modalTitle="임시 계정 삭제"
      isDeleteModal={true}
      isSmallModal={true}
      closeEvent={() => cancelEvent()}
      confirmEvent={() => setDeleteBtnClick(true)}
      type="input"
      confirmDisabled={reason === ""}
    >
      <DeleteModalLabel>삭제 사유</DeleteModalLabel>

      <Textarea
        placeholder="삭제 사유 입력(100글자 이내)"
        onChange={(e) => setReason(e.target.value)}
        value={reason}
      />

      <>{loading && <Loader />}</>
    </DefaultModalLayout>
  );
}
